// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2oT-t","info":"UpdateTermsInfo_info__2b7Pa"};